import HorizontalNav from "./horizontalNav";

export default HorizontalNav;
